import { Trans } from "@lingui/react/macro";
import { AlertTriangleIcon } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

/** Watched IW delete/move rejections rendered at the actual output-error boundary. */
export function IndexWorkerWatchRuleConflictError({
  operation,
}: {
  operation: "delete" | "move";
}) {
  return (
    <Alert variant="destructive" className="text-xs">
      <AlertTriangleIcon className="h-4 w-4" />
      <AlertTitle>
        {operation === "delete" ? (
          <Trans>Index Worker could not be deleted</Trans>
        ) : (
          <Trans>Index Worker could not be moved</Trans>
        )}
      </AlertTitle>
      <AlertDescription>
        {operation === "delete" ? (
          <Trans>
            This Index Worker has watch rules. Delete those watch rules before
            deleting the Index Worker.
          </Trans>
        ) : (
          <Trans>
            This Index Worker has watch rules. Delete those watch rules before
            moving the Index Worker.
          </Trans>
        )}
      </AlertDescription>
    </Alert>
  );
}
